import script from "./AdditionalProfileDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalProfileDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalProfileDetails.vue?vue&type=style&index=0&id=a9039f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9039f3a"]])

export default __exports__